/** Canonical Morrow help and legal destinations from morrowos.com. */

export const MORROW_SITE_ORIGIN = "https://www.morrowos.com";

export const MORROW_SUPPORT_URLS = {
  helpCenter: `${MORROW_SITE_ORIGIN}/support`,
  submitRequest: `${MORROW_SITE_ORIGIN}/support#ticket`,
  helpTopics: `${MORROW_SITE_ORIGIN}/support#topics`,
  systemStatus: `${MORROW_SITE_ORIGIN}/status`,
  setup: `${MORROW_SITE_ORIGIN}/#how`,
  integrations: `${MORROW_SITE_ORIGIN}/integrations`,
  companyMemory: `${MORROW_SITE_ORIGIN}/#brain`,
  securityPrivacy: `${MORROW_SITE_ORIGIN}/trust`,
  billing: `${MORROW_SITE_ORIGIN}/pricing`,
  faq: `${MORROW_SITE_ORIGIN}/#faq`,
  bookCall: "https://app.cal.com/vlknctn",
} as const;

export const MORROW_LEGAL_URLS = {
  privacy: `${MORROW_SITE_ORIGIN}/privacy`,
  terms: `${MORROW_SITE_ORIGIN}/terms`,
  dpa: `${MORROW_SITE_ORIGIN}/dpa`,
  cookies: `${MORROW_SITE_ORIGIN}/cookies`,
  trust: `${MORROW_SITE_ORIGIN}/trust`,
  company: "https://enortic.com/",
} as const;

export const MORROW_CONTACT = {
  supportEmail: "hi@enortic.com",
  securityEmail: "security@enortic.com",
  legalEmail: "legal@enortic.com",
  phoneDisplay: "+1 (302) 546-5141",
  phoneTel: "tel:+13025465141",
  companyName: "Enortic, Inc.",
  companyAddress: "Dover, DE 19904, United States",
} as const;

export function mailtoHref(email: string): string {
  return `mailto:${email}`;
}
